import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { initReactI18next } from 'react-i18next';
import ar from './assets/locales/ar.json';
import az from './assets/locales/az.json';
import bn from './assets/locales/bn.json';
import cs from './assets/locales/cs.json';
import de from './assets/locales/de.json';
import el from './assets/locales/el.json';
import en from './assets/locales/en.json';
import es from './assets/locales/es.json';
import fi from './assets/locales/fi.json';
import fr from './assets/locales/fr.json';
import hi from './assets/locales/hi.json';
import hu from './assets/locales/hu.json';
import it from './assets/locales/it.json';
import kk from './assets/locales/kk.json';
import ko from './assets/locales/ko.json';
import ky from './assets/locales/ky.json';
import mn from './assets/locales/mn.json';
import mr from './assets/locales/mr.json';
import ms from './assets/locales/ms.json';
import ne from './assets/locales/ne.json';
import no from './assets/locales/no.json';
import pl from './assets/locales/pl.json';
import pt from './assets/locales/pt.json';
import ro from './assets/locales/ro.json';
import ru from './assets/locales/ru.json';
import si from './assets/locales/si.json';
import sk from './assets/locales/sk.json';
import sv from './assets/locales/sv.json';
import sw from './assets/locales/sw.json';
import ta from './assets/locales/ta.json';
import te from './assets/locales/te.json';
import tg from './assets/locales/tg.json';
import th from './assets/locales/th.json';
import tk from './assets/locales/tk.json';
import tl from './assets/locales/tl.json';
import tr from './assets/locales/tr.json';
import uk from './assets/locales/uk.json';
import ur from './assets/locales/ur.json';
import uz from './assets/locales/uz.json';
import vi from './assets/locales/vi.json';

const resources = {
    ar: { translation: ar },
    az: { translation: az },
    bn: { translation: bn },
    cs: { translation: cs },
    de: { translation: de },
    el: { translation: el },
    en: { translation: en },
    es: { translation: es },
    fi: { translation: fi },
    fr: { translation: fr },
    hi: { translation: hi },
    hu: { translation: hu },
    it: { translation: it },
    kk: { translation: kk },
    ko: { translation: ko },
    ky: { translation: ky },
    mn: { translation: mn },
    mr: { translation: mr },
    ms: { translation: ms },
    ne: { translation: ne },
    no: { translation: no },
    pl: { translation: pl },
    pt: { translation: pt },
    ro: { translation: ro },
    ru: { translation: ru },
    si: { translation: si },
    sk: { translation: sk },
    sv: { translation: sv },
    sw: { translation: sw },
    ta: { translation: ta },
    te: { translation: te },
    tg: { translation: tg },
    th: { translation: th },
    tk: { translation: tk },
    tl: { translation: tl },
    tr: { translation: tr },
    uk: { translation: uk },
    ur: { translation: ur },
    uz: { translation: uz },
    vi: { translation: vi }
};

export type Language = keyof typeof resources;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init(
        {
            // lng: 'en', // if you're using a language detector, do not define the lng option
            // debug: true,
            defaultNS: 'translation',
            fallbackLng: 'en',
            resources: resources,
            detection: {
                order: [
                    'querystring',
                    'path',
                    'cookie',
                    'localStorage',
                    'sessionStorage',
                    'navigator',
                    'htmlTag',
                    'subdomain'
                ],
                lookupQuerystring: 'lang', // -- TODO look into this one
                convertDetectedLanguage(lng) {
                    return lng.toLowerCase();
                }
            }
        },
        function (err, t) {
            err && console.error(err);
        }
    );
